import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-5 flex flex-wrap items-center justify-between gap-3" }
const _hoisted_2 = { class: "flex items-center gap-3 text-right" }
const _hoisted_3 = { class: "flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 text-indigo-700" }
const _hoisted_4 = { class: "mt-1 text-xs text-slate-500" }
const _hoisted_5 = { class: "mb-5 grid grid-cols-2 gap-2" }
const _hoisted_6 = { class: "space-y-4 rounded-2xl border border-slate-200 bg-slate-50/70 p-3 sm:p-5" }
const _hoisted_7 = { class: "flex flex-wrap items-center justify-between gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "users-list pa-2 my-3 sm:pa-4 sm:my-6"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        flat: "",
        class: "notification-card pa-3 rounded-2xl sm:pa-6"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_v_icon, { size: "22" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-bell-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-lg font-bold text-slate-900" }, "اطلاع‌رسانی به کاربران", -1)),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.user ? 'ارسال پیام مستقیم به کاربر انتخاب‌شده' : 'ارسال پیام به گروهی از کاربران'), 1)
                ])
              ]),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                rounded: "lg",
                class: "text-caption font-weight-medium",
                "prepend-icon": "mdi-arrow-right",
                onClick: _ctx.back
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" بازگشت به کاربران ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, index) => {
                return (_openBlock(), _createBlock(_component_v_btn, {
                  key: index,
                  block: "",
                  rounded: "lg",
                  color: button.value === _ctx.activeFilterButton ? 'primary' : 'default',
                  variant: button.value === _ctx.activeFilterButton ? 'flat' : 'outlined',
                  class: "text-caption font-weight-medium",
                  disabled: button.disabled,
                  onClick: ($event: any) => (_ctx.setFilterOfUsersList(button.value))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(button.title), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "variant", "disabled", "onClick"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.user)
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    modelValue: _ctx.notificationType,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notificationType) = $event)),
                      _ctx.handleNotificationTypeChange
                    ],
                    items: _ctx.notificationOptions,
                    "item-title": "title",
                    "item-value": "value",
                    label: "مخاطب اطلاع‌رسانی",
                    variant: "outlined",
                    density: "comfortable",
                    "hide-details": ""
                  }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_textarea, {
                modelValue: _ctx.notificationMessage,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.notificationMessage) = $event)),
                label: "متن پیام",
                variant: "outlined",
                density: "comfortable",
                rows: "5",
                counter: "1000",
                maxlength: "1000",
                "hide-details": "",
                placeholder: "متن اطلاع‌رسانی خود را اینجا وارد کنید"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs text-slate-500" }, "پیش از ارسال، گروه مخاطبان و متن پیام را بررسی کنید.", -1)),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  rounded: "lg",
                  class: "min-w-[190px] text-caption font-weight-medium",
                  "prepend-icon": "mdi-send",
                  disabled: !_ctx.notificationMessage.trim() || (!_ctx.user && !_ctx.notificationType),
                  onClick: _ctx.submitNotification
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" ارسال اطلاع‌رسانی ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}